
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonAvatar } from '@ionic/vue';

export default  {
  name: 'MyDashboard',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonAvatar }
}
